export default __webpack_public_path__ + "static/uiux-transforming-a5c51c03a3c17973c0d07e0c3b0a5345.png";